import {getUserProperty} from "./userProfile";

const postLogin = () => {
    const loginFormElement = document.querySelector('#foPostLoginForm');
    const returnContextField = loginFormElement.returnContext;
    try {
        const locationObject = window.location;
        const accountId = getUserProperty('accountId');
        let search = locationObject.search;
        if (accountId) {
            search = search.match(/(\?|&)ACCOUNTID=/) ?
                search.replace(/ACCOUNTID=[0-9]*/, `ACCOUNTID=${accountId}`) :
                search + (search ? '&' : '?') + `ACCOUNTID=${accountId}`;
            returnContextField.value = locationObject.pathname + search + locationObject.hash;
        } else {
            returnContextField.value = locationObject.href.replace(locationObject.origin, '');
        }

        loginFormElement.submit();
    } catch (e) {
        window && window.console && window.console.log(e);
    }
};

const postLogout = (value) => {
    const logoutFormElement = document.querySelector('#foPostLogoutForm');
    const returnContextField = logoutFormElement.returnContext;
    try {
        returnContextField.value = value ? value : window.location.href.replace(window.location.origin, '');
        logoutFormElement.submit();
    } catch (e) {
        window && window.console && window.console.log(e);
    }
};

export {postLogin, postLogout}


// WEBPACK FOOTER //
// ./src/app/utils/postLoginLogout.js